import React from 'react';

import classes from './NewInputDropDown.module.css';

import DropDownIcon from '../../../assets/icons/dropdown-arrow-blue.svg';
import { IsListEmpty, IsStringEmpty } from '../../../utilities/CommonMethods';
// import Backdrop from '../Backdrop/Backdrop';
import CheckIconWhite from '../../../assets/icons/check-white.svg';

class NewInputDropDown extends React.Component {

    state = {
        itemsList: [],
        activeItemPos: 0,
        dropdownOpen: false,
        activeItemName: "",
    }

    onDropdownItemClicked = (id) => {
        let itemList = this.props.dropdownItemsList;
        let activeItemPos = null;
        for (let i = 0; i < itemList.length; i++) {
            if (id === itemList[i].id) {
                activeItemPos = i;
                break;
            }
        }
        const activeItemName = this.state.itemsList[activeItemPos].name;
        this.setState({ activeItemPos: activeItemPos, activeItemName: activeItemName, dropdownOpen: false });

        if (this.props.roundIndex > -1)
            this.props.dropdownItemClicked(activeItemPos, this.props.roundIndex);
        else
            this.props.dropdownItemClicked(activeItemPos);
    }

    onDropdownClicked = () => {
        let status = this.state.dropdownOpen;
        this.setState({ dropdownOpen: !status });
    }

    filterList = (event) => {
        let initialDataList = this.props.dropdownItemsList;
        let finalList = !IsListEmpty(initialDataList) ? initialDataList.filter((item, index) => {
            if (item.name.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1) return true;
        }) : [];
        this.setState({
            filteredItemsList: finalList,
            dropdownOpen: true,
            activeItemName: event.target.value
        })
    }

    componentDidMount() {

        if (this.props.forEditModuleForm) {
            const index = this.props.dropdownItemsList.length > this.props.activeItemPos ? this.props.activeItemPos : 0;

            const activeItemName = this.props.placeholder ? this.props.placeholder : !IsListEmpty(this.props.dropdownItemsList) ? this.props.dropdownItemsList[index].name : '-';

            this.setState({ itemsList: this.props.dropdownItemsList, activeItemPos: index, activeItemName: activeItemName, dropdownOpen: false, filteredItemsList: this.props.dropdownItemsList });
        } else {
            const activeItemName = this.props.placeholder ? this.props.placeholder : !IsListEmpty(this.props.dropdownItemsList) ? this.props.dropdownItemsList[0].name : '-';

            this.setState({ itemsList: this.props.dropdownItemsList, activeItemPos: 0, activeItemName: activeItemName, dropdownOpen: false, filteredItemsList: this.props.dropdownItemsList });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.dropdownItemsList !== this.props.dropdownItemsList) {
            const activeItemName = !IsListEmpty(this.props.dropdownItemsList) ? this.props.dropdownItemsList[0].name : '-'
            this.setState({ itemsList: this.props.dropdownItemsList, activeItemName: activeItemName, activeItemPos: 0, dropdownOpen: false });
        }
        if (prevProps.activeItemPos !== this.props.activeItemPos) {
            const activeItemName = !IsListEmpty(this.props.dropdownItemsList) ? this.props.dropdownItemsList[this.props.activeItemPos].name : '-';
            this.setState({ activeItemPos: this.props.activeItemPos, activeItemName: activeItemName, dropdownOpen: false });
        }

        if (prevProps.isModulesFetched !== this.props.isModulesFetched) {
            this.setState({ filteredItemsList: this.props.dropdownItemsList })
        }
    }

    render() {
        const renderItemsList = !IsListEmpty(this.state.filteredItemsList) ? this.state.filteredItemsList.map((item, index) => {
            return (
                <li key={index}
                    className={[classes.Item, classes.FullWidth,
                    index === this.state.activeItemPos ? classes.Active : ''].join(' ')}
                    onClick={() => this.onDropdownItemClicked(item.id)}>
                    <div className={classes.ListItems}>
                        <div className={[classes.CheckIconDiv, this.props.multiple ? classes.Square : classes.Round,
                        index === this.state.activeItemPos ? classes.ActiveCheckIcon : null].join(' ')}>
                            <img src={CheckIconWhite} alt="Option Checked Icon" className={[classes.CheckIcon,
                            index === this.state.activeItemPos ? classes.ShowImage : null].join(' ')} />
                        </div>
                        {
                            this.props.forFormPage
                                ? <p className={classes.TopicName} title={item.topicName}>
                                    <span className={classes.WeekDate}>
                                        {
                                            this.props.showBatchCode === true
                                                ? !IsStringEmpty(item.batchCode) ? item.batchCode : '-'
                                                : !IsStringEmpty(item.name) ? item.name : '-'
                                        }
                                    </span>
                                    {
                                        this.props.reduceTopMargin && !IsStringEmpty(item.email)
                                            ? <span className={classes.Email}>{!IsStringEmpty(item.email) ? `(${item.email})` : '-'}</span>
                                            : null
                                    }
                                </p>
                                : <p className={classes.TopicName} title={item.topicName}>
                                    {!IsStringEmpty(item.name) ? item.name.split(' | ')[0] : '-'}
                                    <span className={classes.WeekDate}>{!IsStringEmpty(item.name) ? item.name.split(' | ')[1] : '-'}</span>
                                </p>
                        }
                    </div>
                </li>
            );
        }) : <li className={classes.Item}>
            <p className={classes.MessageText}>Data Not Available</p>
        </li>

        return (
            <>
                <div className={classes.InputDropDownContainer}>
                    <div>
                        <p className={classes.SubText}>{this.props.title}</p>
                        <div className={classes.SelectedTopicDiv}  >
                            <input onChange={(event) => this.filterList(event)} value={this.state.activeItemName} className={[classes.FieldInputBox, this.props.module === true ? classes.MarginBottom : '', this.props.padding === true ? classes.PaddingBottom : ''].join(' ')} onClick={this.props.hideDropdownIcon === true ? null : this.onDropdownClicked} />
                            {
                                this.props.hideDropdownIcon === true
                                    ? null
                                    : <img src={DropDownIcon} alt="Input Dropdown Icon" className={[classes.DropDownIcon, this.state.dropdownOpen ? classes.Open : ''].join(' ')} />
                            }
                        </div>
                    </div>
                    <div className={[classes.DropdownListContainer, this.props.forFormPage ? classes.FixedHeight : '', this.props.reduceTopMargin ? classes.ReduceTopMargin : ''].join(' ')}>{
                        this.state.dropdownOpen
                            ? <div className={classes.ItemsListContainer}>
                                <ul className={classes.WeekItemsList}>
                                    {renderItemsList}
                                </ul>
                            </div>
                            : null}</div>

                </div>
            </>
        );
    }
}

export default NewInputDropDown;